import { Skeleton } from '@/components/ui/skeleton';

export function ServiceCardSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-3 p-3 md:grid-cols-2">
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="group/card relative flex h-[500px] w-full items-center justify-center overflow-hidden shadow"
        >
          <Skeleton className="h-full w-full" />

          <div className="absolute bottom-0 left-0 z-10 h-fit w-full p-10">
            <div className="flex flex-col items-center justify-center space-y-1 text-center">
              <Skeleton className="h-8 w-48 rounded-full" />
              <Skeleton className="h-4 w-64 rounded-full" />
              <div className="flex gap-2 pt-2">
                <Skeleton className="h-10 w-28 rounded-full" />
                <Skeleton className="h-10 w-28 rounded-full" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
